import React, { memo, useMemo, useCallback, useState } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import AxiomMultiSelectCheckboxes from "__AxiomComponents/AxiomMultiSelectCheckboxes/AxiomMultiSelectCheckboxes.js";
import AxiomTagSelection from "__AxiomComponents/AxiomTagSelection/AxiomTagSelection";
import { useTagSelection } from "__AxiomComponents/AxiomTagSelection/AxiomTagSelectionHooks";
import AxiomSelect from "__AxiomComponents/AxiomSelect/AxiomSelect.jsx";
import { emailDropDownData } from "./Constant";
import "./HawkeyeV2AddPost.scss";

function HawkeyeV2AddPost(props) {
  const {
    collaborators,
    onPostAdd,
    onPostEdit,
    closeAddPost,
    closeEditPost,
    postName,
    onPostNameChange,
    postDescription,
    onPostDescriptionChange,
    onAllCollaboratorsSelection,
    onColaboratorSelection,
    selectedCollaborators,
    isAllCollaboratorsSelected,
    allCollaborators,
    allAssignedCollaborators,
    assignedCollaborator,
    onCollaboratorAssigned,
    dueDate,
    setDueDate,
    editing,
    canEditNameDesc,
    emailSettings,
  } = props;

  const [emailConfiguration, setEmailConfiguration] = useState(emailSettings || {});

  const onAddPost = () =>
    onPostAdd(
      postName,
      postDescription,
      selectedCollaborators,
      assignedCollaborator,
      dueDate,
      emailConfiguration
    );

  const isValid = () => {
    if (postName && postDescription && selectedCollaborators.length > 0) return 1;
    else return 0;
  };

  const onAssigneCollaborator = (key, value) => onCollaboratorAssigned(key, value);

  const onEditPost = () =>
    onPostEdit(
      postName,
      postDescription,
      selectedCollaborators,
      assignedCollaborator,
      dueDate,
      emailConfiguration
    );

  const changeEmailSettings = useCallback(
    (data) => {
      const newEmailSettings = { ...emailSettings };
      Object.keys(newEmailSettings).map((d) => {
        newEmailSettings[d] = false;
      });
      data.forEach((d) => {
        newEmailSettings[d.value] = true;
      });
      setEmailConfiguration(newEmailSettings);
    },
    [setEmailConfiguration, emailSettings]
  );

  const emailSettingsData = useMemo(() => {
    let emailData = [];
    Object.keys(emailConfiguration).forEach((d) => {
      if (emailDropDownData[d]) {
        emailData.push({
          label: emailDropDownData[d],
          value: d,
        });
      }
    });
    return emailData;
  }, [emailConfiguration]);

  const selectedEmailData = useMemo(() => {
    let selectedData = [];
    Object.keys(emailConfiguration).forEach((d) => {
      if (emailConfiguration[d] && emailDropDownData[d]) {
        selectedData.push({
          label: emailDropDownData[d],
          value: d,
        });
      }
    });
    return selectedData;
  }, [emailConfiguration]);

  return (
    <div className="hawkeye-add-post">
      <div className="hawkeye-form-group">
        <label className="hawkeye-form-label">Conversation Name</label>
        <input
          type="text"
          className="hawkeye-form-control is-full"
          onChange={(e) => onPostNameChange(e.target.value)}
          value={postName}
          disabled={editing && !canEditNameDesc ? true : false}
        />
      </div>
      <div className="hawkeye-form-group">
        <label className="hawkeye-form-label">Conversation Description</label>
        <textarea
          rows="3"
          className="hawkeye-form-control is-full"
          onChange={(e) => onPostDescriptionChange(e.target.value)}
          value={postDescription}
          disabled={editing && !canEditNameDesc ? true : false}
        />
      </div>
      <div className="hawkeye-form-group hawkeye-add-post-details">
        <div>
          <label className="hawkeye-form-label">Assign to</label>
          <AxiomSelect
            value={assignedCollaborator}
            options={allAssignedCollaborators}
            onChange={onAssigneCollaborator}
            multiSelect={false}
            placeholder={"Unassigned"}
            className={"hawkeye-selection-dropdown"}
          />
        </div>
        <div className="hawkeye-add-post-date">
          <label className="hawkeye-form-label">Due date</label>
          <input
            type="date"
            className="hawkeye-form-control"
            onChange={(e) => setDueDate(e.target.value)}
            value={dueDate}
            min={d3.timeFormat("%Y-%m-%d")(new Date())}
          />
        </div>
        <div className="hawkeye-add-post-date">
          <label className="hawkeye-form-label">Email Settings</label>
          <div className="hawkeye-multicheckbox-selection">
            <AxiomMultiSelectCheckboxes
              value={selectedEmailData}
              options={emailSettingsData}
              onChange={(key, value) => {
                changeEmailSettings(value);
              }}
              minWidth={200}
              maxWidth={400}
              maxMenuHeight={250}
            />
          </div>
        </div>
      </div>
      <div className="hawkeye-form-group">
        <label className="hawkeye-form-label">Add Collaborators</label>
        <label className="hawkeye-form-checkbox hawkeye-add-post-all">
          <input
            type="checkbox"
            checked={isAllCollaboratorsSelected}
            onChange={onAllCollaboratorsSelection}
          />
          <span>All Collaborators</span>
        </label>
        <AxiomTagSelection
          options={allCollaborators}
          placeholder={"Search collaborators"}
          selectedOptions={selectedCollaborators}
          onSelection={onColaboratorSelection}
        />
      </div>
      <div className="hawkeye-form-footer">
        <button
          className="hawkeye-btn hawkeye-btn-secondary"
          onClick={editing ? closeEditPost : closeAddPost}
        >
          Cancel
        </button>
        {editing ? (
          <button
            disabled={!isValid()}
            className="hawkeye-btn hawkeye-btn-primary"
            onClick={onEditPost}
          >
            Save
          </button>
        ) : (
          <button
            disabled={!isValid()}
            className="hawkeye-btn hawkeye-btn-primary"
            onClick={onAddPost}
          >
            Add
          </button>
        )}
      </div>
    </div>
  );
}

export default memo(HawkeyeV2AddPost);
